<template>
  <common-card :title="title" class="basic-form">
    <template v-slot:header-ops>
      <el-button
        size="small"
        type="danger"
        plain
        @click="clearInputs"
        v-if="showClear"
      >
        Clear
      </el-button>
      <slot name="actions"> </slot>
    </template>
    <div class="before-content">
      <slot name="before-content"></slot>
    </div>
    <div class="content">
      <el-row
        v-for="(row, indexOne) in rowCols"
        :key="'row-' + indexOne"
        class="each-row"
      >
        <el-col
          v-for="(col, indexTwo) in row"
          :key="'col-' + indexTwo"
          :span="(24 / cols) * col.span"
        >
          <el-row
            class="each-col f-r"
            :style="{ 'min-height': col.height || '34px' }"
          >
            <el-col :span="12 / col.span" class="key">
              <span class="text">{{ col.label }}</span>
              <div class="divider"></div>
            </el-col>
            <el-col :span="24 - 12 / col.span" class="value">
              <div class="text f-r-vc">
                <span v-if="col.type === Text">{{ col.value }}</span>
                <el-tag
                  size="small"
                  :type="getTagType(col)"
                  :effect="col.effect"
                  v-else-if="col.type === Tag && col.value"
                >
                  {{ col.value }}
                </el-tag>
                <div class="f-c" v-else-if="col.type === Time">
                  <span>
                    {{ TimeLocalDate(col.value) }}
                  </span>
                  <span>
                    {{ TimeLocalTime(col.value) }}
                  </span>
                </div>
                <el-checkbox
                  v-else-if="col.type === Checkbox && col.mutable === false"
                  :value="col.value"
                />
                <div
                  class="f-c input-wrap"
                  v-if="EditFormItemTypes.includes(col.type)"
                >
                  <el-input
                    class="line-input"
                    :class="{ error: col.key in inputValueErrors }"
                    v-model="inputValueMap[col.key]"
                    size="small"
                    v-if="col.type === TextInput"
                    @change="value => inputValueChange(value, col)"
                  />
                  <el-select
                    size="small"
                    :class="{ error: col.key in inputValueErrors }"
                    v-if="col.type === Select"
                    v-model="inputValueMap[col.key]"
                    clearable
                    placeholder="Select"
                    @change="value => inputValueChange(value, col)"
                  >
                    <el-option
                      v-for="item in col.options"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <address-pick
                    v-if="col.type === AddressSelect"
                    v-model="inputValueMap[col.key]"
                    @change="value => inputValueChange(value, col)"
                  />
                  <hold-or-not
                    :value="inputValueMap[col.key]"
                    v-if="col.type === HoldTag"
                  />
                  <el-switch
                    v-if="col.type === HoldSelect"
                    v-model="inputValueMap[col.key]"
                    active-text="Hold"
                    inactive-text="Not Hold"
                    :active-value="HOLD"
                    :inactive-value="UNHOLD"
                  >
                  </el-switch>
                  <el-input
                    class="line-input"
                    :class="{ error: col.key in inputValueErrors }"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    v-model="inputValueMap[col.key]"
                    size="small"
                    v-if="col.type === TextArea"
                    @change="value => inputValueChange(value, col)"
                  />
                  <el-date-picker
                    v-if="col.type === TimeSelect"
                    size="small"
                    style="width: 100%;"
                    v-model="inputValueMap[col.key]"
                    :format="TimeFormat"
                    :type="col.timeType ?? 'datetime'"
                    placeholder="Select date and time"
                    @change="value => inputValueChange(value, col)"
                  >
                  </el-date-picker>
                  <el-input-number
                    v-if="col.type === NumberInput"
                    size="small"
                    style="width: 100%;"
                    :format="TimeFormat"
                    v-model="inputValueMap[col.key]"
                    placeholder="0"
                    :min="0"
                    @change="
                      value => {
                        inputValueChange(value, col)
                        emitNumberInput(value)
                      }
                    "
                  >
                  </el-input-number>
                  <el-select
                    v-if="col.type === RemoteSelect"
                    filterable
                    remote
                    size="small"
                    reserve-keyword
                    placeholder="Please enter a keyword"
                    :remote-method="col.method.bind(col)"
                    :loading="col.loading"
                    v-model="inputValueMap[col.key]"
                    @change="value => inputValueChange(value, col)"
                  >
                    <el-option
                      v-for="item in col.options"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                  <div v-if="col.type === Blank"></div>
                  <span v-if="col.key in inputValueErrors">
                    {{ inputValueErrors[col.key] }}
                  </span>
                  <el-checkbox
                    v-if="col.type === Checkbox && col.mutable === true"
                    v-model="inputValueMap[col.key]"
                  />
                  <el-radio-group
                    v-if="col.type === RadioGroup"
                    v-model="inputValueMap[col.key]"
                  >
                    <el-radio
                      v-for="(item, index) in col.options"
                      :key="col.key + '-options-' + index"
                      :label="item.label"
                    >
                      {{ item.value }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="divider" v-if="indexTwo !== row.length - 1"></div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="common-card__bottom-actions">
      <slot name="bottom-actions"> </slot>
    </div>
  </common-card>
</template>
<script>
// others
import { checkArrayEqual } from '@/core/utils/index'
import { FormTypeMixin } from '@/core/mixin/form'
import {
  FormModes,
  EditFormItemTypes,
  BasicFormRowColCal,
  RemoteSelect
} from '@/core/configs/types'
import { HOLD, UNHOLD } from '@/core/models/constant'
import CommonCard from '@/components/common/CommonCard.vue'
import AddressPick from '@/components/address/AddressPick.vue'
import HoldOrNot from './HoldOrNot.vue'
export default {
  name: 'BasicForm',
  components: {
    CommonCard,
    AddressPick,
    HoldOrNot
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    mode: {
      type: Object,
      default: () => FormModes.NORMAL
    },
    formParams: {
      type: Object,
      required: true
    },
    headerOps: {
      type: Array,
      default: () => []
    },
    valueChangeCb: {
      type: Function,
      default: () => {}
    },
    showClear: {
      type: Boolean,
      default: false
    }
  },
  mixins: [FormTypeMixin],
  data() {
    return {
      HOLD,
      UNHOLD,
      emptyKeyValue: {
        key: '',
        value: '',
        span: 1,
        type: 'text'
      },
      inputValueMap: {},
      inputValueErrors: {},
      rowCols: []
    }
  },
  computed: {
    cols() {
      return this.mode.cols
    },
    allParams() {
      return Object.values(this.formParams).map(one => [
        one.key,
        one.type,
        one.value,
        one?.options ?? []
      ])
    }
  },
  watch: {
    allParams(one, two) {
      if (!checkArrayEqual(one, two)) this.getRowColsAndMap()
    },
    formParams() {}
  },
  mounted() {
    this.getRowColsAndMap()
    // fetch all data when it is remote select
    Object.keys(this.formParams).forEach(key => {
      if (this.formParams[key].type === RemoteSelect) {
        this.formParams[key].method()
      }
    })
  },
  methods: {
    changeCols(num) {
      this.cols = num
    },
    getRowColsAndMap() {
      const rowCols = BasicFormRowColCal(
        Object.values(this.formParams),
        this.cols,
        this.emptyKeyValue
      )
      const maps = Object.fromEntries(
        Object.values(this.formParams).map(one => [one.key, one.value])
      )
      this.$set(this, 'inputValueMap', maps)
      this.$set(this, 'rowCols', rowCols)
    },
    inputValueChange(value, formItem) {
      if (typeof value === 'string' || value instanceof String) {
        value = value.trim()
      }
      this.validateKeyValue(formItem, value)
      this.valueChangeCb(formItem.key, value)
    },
    clearInputs() {
      const maps = Object.fromEntries(
        Object.values(this.formParams).map(one => {
          one.value = one.default
          return [one.key, one.default]
        })
      )
      this.$set(this, 'inputValueMap', maps)
    },
    validateKeyValue(keyItem, value) {
      const { validators } = keyItem
      let [i, passed, msg] = [0, true, '']
      while (passed && i < validators.length) {
        ;[passed, msg] = validators[i].call(keyItem, value)
        i++
      }
      if (!passed) {
        this.$set(this.inputValueErrors, keyItem.key, msg)
      } else {
        this.$delete(this.inputValueErrors, keyItem.key)
      }
      return [passed, msg]
    },
    validateAllInputs() {
      const errs = []
      let [passed] = [true]
      const values = {}
      Object.values(this.formParams)
        .filter(item => EditFormItemTypes.includes(item.type))
        .forEach(item => {
          ;[passed] = this.validateKeyValue(item, this.inputValueMap[item.key])
          if (!passed) errs.push(item.key)
          const value = this.inputValueMap[item.key]
          if (value && item.convertor) {
            values[item.key] = item.convertor(value)
          } else values[item.key] = value
        })
      return [errs.length === 0, values]
    },
    emitNumberInput(e) {
      this.$emit('numberInput', e)
    },
    getTagType(item) {
      if (item.tagType) {
        return item.tagType(item.value)
      }
      return 'primary'
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';
$basic-form-row-height: 34px;
$basic-form-text-padding-x: 15px;
$basic-form-border-color: #dcdfe6;
$basic-form-title-bg-color: $info-color;
$basic-form-divider-width: 1px;

.basic-form {
  display: flex;
  flex-direction: column;

  .content {
    @extend .f-c-c-sb;

    .each-row {
      width: 100%;
      border: $basic-form-divider-width solid $basic-form-border-color;
      border-bottom: none;

      @extend .f-r;
    }

    .each-row:last-child {
      border-bottom: $basic-form-divider-width solid $basic-form-border-color;
    }

    .each-col {
      height: 100%;

      .key,
      .value {
        font-size: $title-level-five;

        .text {
          width: calc(100% - $basic-form-divider-width);
        }

        .divider {
          width: $basic-form-divider-width;
          height: 100%;
          background-color: $basic-form-border-color;
        }
      }

      .key {
        // font-size: $regular-body-font-size;
        background-color: $basic-form-title-bg-color;
        // color: rgba($color: #000, $alpha: 0.65);
        color: #625b5b;
        font-weight: 500;

        @extend .f-r-vc;

        .text {
          padding: 0 $basic-form-text-padding-x;
        }
      }

      .value {
        @extend .f-r-vc;

        color: black;

        .text {
          height: calc(100% - 10px);
          padding: 5px $basic-form-text-padding-x;
          word-break: break-all;
        }
      }
    }
  }
}

.input-wrap {
  width: 100%;
  height: 100%;
  justify-content: center;

  span {
    font-size: 11px;
    color: $el-danger-color;
  }
}

.common-card__bottom-actions {
  margin-top: 10px;
}

// .el-radio-group {
//   @extend .f-r;
//   .el-radio {
//     margin-right: 10px;
//   }
// }
</style>
